import React from "react";
import { ReactComponent as CarousleUndeline } from "../../assests/carousleUndeline.svg";

function PrizeWithText({ heading, prizeDetails, hexCode,scrollRef }) {
  var coverStyle = {
    background: `linear-gradient(81.11deg, rgba(86, 86, 86, 0.4) 25.51%, rgba(21, 21, 21, 0.4) 74.24%) `,
  };
  var linkStyle = { color: hexCode };
  return (
    <div
      className=" h-[194px] w-[320px] shrink-0 flex-grow "
      style={coverStyle}
      ref={scrollRef}
    >
      <div className="pt-[20px] px-[20px]">
        <p className="text-small">{heading}</p>
        <div className="no-scrollbar overflow-y-scroll w-[100%] h-[100%] pt-[10px] ">
          <div className="w-[100%] h-[100%] grid">
            <div className="flex items-start justify-start gap-[14px] ">
              <div>
                <p className="text-with-outline ">{prizeDetails?.heading}</p>
                <p className=" text-small text-[#606060] text-five-line">
                  {prizeDetails?.subHeading}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CarousleUndeline
        style={{ width: "100%", height: "auto", color: hexCode }}
      />
    </div>
  );
}

export default PrizeWithText;
